/**
 * Features que se pueden apagar sin sacar el código. Se leen en build time, así
 * que cambiar un valor requiere rebuild.
 */
export const FEATURES = {
  /**
   * Archivado de escrituras. Apagado hasta que el cliente lo pida; se prende
   * junto con `FEATURE_ARCHIVADO_ESCRITURAS` en el backend.
   */
  archivadoEscrituras: import.meta.env.VITE_FEATURE_ARCHIVADO_ESCRITURAS === 'true',
};
